import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { isBoolean } from 'util';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { LoadingService } from 'projects/services/src/app/loading.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SweetAlertDirective } from '../sweet-alert.directive';
import { TrainingPartnerService } from 'projects/services/src/app/API/training-partner.service';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
declare const swal: any;
import { ApiService } from 'projects/services/src/app/API/api.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dashboard-card',
    templateUrl: './dashboard-card.component.html',
    styleUrls: ['./dashboard-card.component.css']
})
export class DashboardCardComponent implements OnInit {
    @Input() dashboardCards: { routerLink: string, name: string }[];
    @Input() title: string;
    @Input() description: string;
    @Input() logoUrl: string = '../../../assets/images/process.svg';
    @Input() route: string;
    @Input() queryParams: any;
    @Input() queryParamsOriginal: any;
    @Input() relative: true;
    @Input() cardWidth: string = 'max-width;';
    @Input() setOwnCardWidth: boolean = false;
    @Input() link: string;
    @Input() hyperLink: string;
    @ViewChild('closeModal') closeModal: ElementRef;
	registrationForm: FormGroup;
	selectedFile: File;
	isBadData: any;
	selectedFileName = 'Choose File';
	visible = {
		registerModal: false
	};
	toasterMessage = new SweetAlertDirective();
	errorMessage = '(Allowed formats xlsx, xls)';
	showForm = false;
	showUpload: any;
	showCompleteForm = false;
    role: string = '';
    user:any;
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private fileService: FileService,
        private loadingService: LoadingService,
        private formBuilder: FormBuilder,
        private trainingPartnerService: TrainingPartnerService,
        private batchService: BatchService,
        private currentUserService: CurrentUserService,
        private apiService: ApiService,
    ) {
        this.dashboardCards = [];
        this.registrationForm = formBuilder.group({
			senderName: ["", [Validators.required]],
			excelFile: [undefined, [Validators.required]]
		});
        this.currentUserService.getCurrentUser().subscribe(user => {
            this.role = user.role;
            this.user = user;
        });
    }

    ngOnInit() {
        this.relative = isBoolean(this.relative) ? this.relative : true
    }

    onClick() {
        if (this.title === 'Certified Data For Reporting') {
            Helpers.openModal('m_modal_1')
            this.registrationForm.get('excelFile').setValue(undefined);
            this.selectedFileName = ''
            this.registrationForm.reset();
        }
        const options: any = {};
        if (this.relative) {
            options.relativeTo = this.activatedRoute;
        }
        if (this.queryParamsOriginal) {
            options.queryParams = this.queryParamsOriginal;
        }
        if (this.queryParams) {
            // this.router.navigate([this.route, this.queryParams], options);  //changed due to not getting querry params
            if (this.role === 'SEO') {
                this.router.navigate([this.route],{ queryParams: this.queryParams });
            } else {
                this.router.navigate([this.route, this.queryParams], options);
            }
        } else if (this.link !== '' && this.link !== undefined) {
            console.log(this.link);
            this.fileService.getS3SignedURLPublic(this.link).subscribe((res: any) => {
                const link: string = res
                window.open(link, '_blank')
            })
        } else if (this.hyperLink !== '' && this.hyperLink !== undefined) {
            swal({
                title: `You are being redirected to an external link...`,
                type: 'info',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 3000
            }).then((setTimeout(() => {
                window.open(this.hyperLink, '_blank');
            }, 2000)));
        } else {
            this.router.navigate([this.route], options);
        }
    }

    onFileSelect(event) {
		const file = event.target.files[0];
		if (file !== undefined) {
			if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
				this.errorMessage = 'Please select appropriate type (Allowed formats xlsx, xls)';
				this.selectedFileName = 'Choose File';
				this.registrationForm.get('excelFile').setErrors({ required: true });
			} else {
				this.selectedFileName = (file.name.length > 20) ? `${file.name.substring(0, 20)}...` : file.name;
				this.selectedFile = file;
				this.errorMessage = '';
				this.registrationForm.get('excelFile').setErrors(null);
			}
		} else {
			this.selectedFileName = 'Choose File';
			this.errorMessage = '(Allowed formats xlsx, xls)';
		}
		console.log(file);
	}

    clearForm() {
        this.registrationForm.get('excelFile').setValue(undefined);
        this.selectedFileName = ''
        this.registrationForm.reset();
        this.errorMessage = '(Allowed formats xlsx, xls)';

    }
    registerCandidate() {
        if (this.registrationForm.value.senderName !== "") {
            console.log("**********************file", this.selectedFile, this.registrationForm.value.senderName)
            let sender = this.registrationForm.value.senderName;
            this.clearForm();
            let userName;
            if(this.user && this.user.role === 'Ministry Admin'){
                userName = this.user.userName;
            }
            this.batchService.excelUpload(this.selectedFile,sender, userName).subscribe(data => {
                console.log("*****************", data)
                let sucessMessage = '';
				if (data.success === true) {
					sucessMessage= data.message;
				}
				this.closeModal.nativeElement.click();
				const message = sucessMessage ?
					`${sucessMessage}` :
					`${sucessMessage}`;
				const alertType = sucessMessage ? 'success' : 'warning';
				this.toasterMessage.toastrAlert({ alertType, message });
				this.selectedFile = null;
				this.selectedFileName = '';
			})
		}
	}

    downloadMinistryTemplate(){
        // this.batchService.downloadExcelTemplate(this.user.userName).subscribe((res:any)=>{
        //     console.log("----------------->>>>>>>", res);
        // })
        const apiUrl = `${environment.userServiceUrl}/api/user/v1/ministry/report/${this.user.userName}`;
        const type = 'application/vnd.ms-excel';
        this.apiService.getBlobOnArguments(apiUrl, {}, type).subscribe(
            res => {
                console.log(res);
                // const fileName = `MINISTRY${new Date()}.xlsx`;
                const fileName = `Ministry_Report.xlsx`;
                this.fileService.downloadFromBlob(res, fileName);
            },
            err => {
                console.log(err, 'error in download');
            }
        );
    }

}
